export var THEME_DARK = 'dark';
export var THEME_LIGHT = 'light';
export var THEME_AUTO = 'auto';

// 主题类型
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
var ThemeTypes = tuple(THEME_DARK, THEME_LIGHT, THEME_AUTO);